import axiosInstance from 'api/axiosInstance'

export const getPayoutsTransactions = async (params: { page: number }) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/earnings/transactions',
        params
    })

    return {
        nextCursor:
            params.page < data?.data?.pagination?.last_page
                ? params.page + 1
                : undefined,
        prevCursor: params.page > 1 ? params.page - 1 : undefined,
        page: {
            data
        }
    }
}


export const getCurrentBalance = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/earnings/balance'
    })

    return data.data
}

export const getEarningsGraphData = async ({
    dateFrom,
    dateTo,
    all_time
}: {
    dateFrom: string
    dateTo: string
    all_time?: string
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/earnings/chart',
        params: {
            date_from: dateFrom,
            date_to: dateTo,
            chart: true,
            all_time
        }
    })

    return data?.data
}

export const getPayoutsInvoices = async (params: {
    page: number
    search?: string
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/payout/lists',
        params: {
            page: params.page,
            ...(params.search && { search: params.search })
        }
    })

    return {
        nextCursor:
            params.page < data?.data?.pagination?.last_page
                ? params.page + 1
                : undefined,
        prevCursor: params.page > 1 ? params.page - 1 : undefined,
        page: {
            data
        }
    }
}

export const requestPayout = async (amount : number): Promise<any> => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/payout/request-payout',
        params: {
            amount
        }
    });
    return data;
};

export const requestManualPayout = async (): Promise<any> => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/payout/manual-payout',
    })

    return data
}
